'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { THEME_STORAGE_KEY } from '@/lib/constants';

/**
 * Light/dark theme. Dark is the default for everyone (the approved canideal.org
 * design); a visitor's choice persists in localStorage and syncs across tabs.
 * next-themes renders the one blocking init script (top of <body>, before any
 * content) that sets the stored html class before first paint — no flash, and
 * no second theme script is needed. layout.tsx keeps suppressHydrationWarning
 * on <html> (server-rendered with the default class="dark").
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      themes={['dark', 'light']}
      defaultTheme="dark"
      enableSystem={false}
      storageKey={THEME_STORAGE_KEY}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
